// import {bootstrap} from '../../node_modules/bootstrap/dist/js/bootstrap.bundle.js'
// import fontawesome from '@fortawesome/fontawesome-free/js/all.js';
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";

AOS.init({
  duration: 1000,
  // offset: 300,
});

let typing = new Typed(".text", {
  strings: ["Front-end Developer", "Full-stack Developer", "Web-Developer"],
  typeSpeed: 100,
  backSpeed: 50,
  loop: true,
});

const SlideBtnEL = document.querySelector(".slide-btn");
const SlideTextLeftELs = document.querySelectorAll(".left-text");
let SlideTextLeftELsR = [];
SlideTextLeftELs.forEach((SlideTextLeftEL) => {
  SlideTextLeftELsR.push(SlideTextLeftEL);
});
SlideTextLeftELsR.reverse();
let textFlag = false;

//prssing button
SlideBtnEL.addEventListener("click", () => {
  switch (textFlag) {
    case true:
      gsap.to(SlideBtnEL, 1, {
        rotation: 0,
        ease: "elastic.out(0.4, 0.45)",
      });

      SlideTextLeftELs.forEach(function (SlideTextLeftEL, index) {
        gsap.to(SlideTextLeftEL, 1.5, {
          delay: (index + 1) * 0.1,
          x: -1500,
          opacity: 0,
          ease: "elastic.out(0.4, 0.45)",
          onStart: function () {
            switch (index) {
              case 0:
                SlideTextLeftEL.innerText =
                  "Hi, my name is Jun Hyeong Park. You can call me just Jun. I’m from South Korea. My university is Soongsil University in Seoul. I have finished my senior course, and I’m going to graduate in this year.";
                break;
              case 1:
                SlideTextLeftEL.innerText =
                  "My major is global media, I was able to study programming languages such as C++, C#, JS, and Python. Also, I have learned designing skills like photoshop, illustrator, premiere pro, and blender.";
                break;
            }
          },
        });
      });
      SlideTextLeftELsR.forEach(function (SlideTextLeftEL, index) {
        gsap.to(SlideTextLeftEL, 1.5, {
          delay: (index + 1) * 0.8,
          x: 0,
          opacity: 1,
          ease: "elastic.out(0.3, 0.45)",
        });
      });
      textFlag = false;
      break;
    case false:
      gsap.to(SlideBtnEL, 1, {
        rotation: 900,
        ease: "elastic.out(0.4, 0.45)",
      });

      SlideTextLeftELs.forEach(function (SlideTextLeftEL, index) {
        gsap.to(SlideTextLeftEL, 1.5, {
          delay: (index + 1) * 0.1,
          x: -1500,
          opacity: 0,
          ease: "elastic.out(0.4, 0.45)",
          onStart: function () {
            switch (index) {
              case 0:
                SlideTextLeftEL.innerText =
                  "I have some ideas to contribute good points to the world with development. To realize my ideas, I have been studying programming skills in languages, algorithms, VCM, and so on.";
                break;
              case 1:
                SlideTextLeftEL.innerText =
                  "To be a good programmer, I'm going to study programming skills again and again. My final goal is to be a developer made a company that changes people's lifestyles like Apple, Uber, and Instacart.";
                break;
            }
          },
        });
      });
      SlideTextLeftELsR.forEach(function (SlideTextLeftEL, index) {
        gsap.to(SlideTextLeftEL, 1.5, {
          delay: (index + 1) * 0.8,
          x: 0,
          opacity: 1,
          ease: "elastic.out(0.3, 0.45)",
        });
      });
      textFlag = true;
      break;
  }
});

//graph
const arrowBtn = document.querySelector(".arrow");
const cirCanELI = document.querySelector(".canvas-wrapper");
const cirCanEL = document.querySelector(".CirCan").getContext("2d");

const workEL = document.querySelector(".work-contect");
const workBtnEL = document.querySelector(".work-btn-area");

const CanBtnEls = document.querySelectorAll(".list-group-item");
CanBtnEls.forEach(function (CanBtnEl, index) {
  CanBtnEl.addEventListener("click", () => {
    if (index == 1) {
      cirCanELI.style.display = "block";
      arrowBtn.style.display = "block";
    } else {
      cirCanELI.style.display = "none";
      arrowBtn.style.display = "none";
    }
    if (index == 2) {
      workEL.style.display = "flex";
      workBtnEL.style.display = "flex";
    } else {
      workEL.style.display = "none";
      workBtnEL.style.display = "none";
    }
  });
});

const cirChart = new Chart(cirCanEL, {
  type: "doughnut",
  data: {
    labels: ["Front-end", "Back-end", "CT", "Design", "Creativity"],
    datasets: [
      {
        borderWidth: 0,
        label: "My skills",
        data: [90, 50, 80, 60, 70],
        backgroundColor: [
          "rgb(255, 190, 11)",
          "rgb(251, 86, 7)",
          "rgb(255, 0, 110)",
          "rgb(131, 56, 236)",
          "rgb(58, 134, 255)",
        ],
        hoverOffset: 3,
      },
    ],
  },
});

//arrow
let upInteractive = true;

function autoToggle() {
  arrowBtn.className += " auto";
}

arrowBtn.addEventListener("hover", function () {
  upInteractive = true;
  arrowBtn.removeClass("auto");
});

setInterval(function () {
  if (upInteractive === false) {
    autoToggle();
  }
}, 2000);

//work section
const workColorELs = document.querySelectorAll(".color-work");
const workInnerELs = document.querySelectorAll(".inner-work");

workColorELs.forEach(function (workColorEL, index) {
  workColorEL.addEventListener("click", function () {
    gsap.to(workColorEL, 0.1, {
      opacity: 0,
      onComplete: function () {
        workColorEL.style.display = "none";

        gsap.to(workInnerELs[index], 0.25, {
          opacity: 1,
          onInit: function () {
            workInnerELs[index].style.display = "flex";
          },
        });
      },
    });
  });
  workInnerELs[index].addEventListener("click", function () {
    gsap.to(workInnerELs[index], 0.25, {
      opacity: 0,
      onComplete: function () {
        workInnerELs[index].style.display = "none";

        gsap.to(workColorEL, 0.25, {
          opacity: 1,
          onInit: function () {
            workColorEL.style.display = "flex";
          },
        });
      },
    });
  });
});

class TextScramble {
  constructor(el) {
    this.el = el;
    this.chars = "!<>-_\\/[]{}—=+*^?#________";
    this.update = this.update.bind(this);
  }
  setText(newText) {
    const oldText = this.el.innerText;
    const length = Math.max(oldText.length, newText.length);
    const promise = new Promise((resolve) => (this.resolve = resolve));
    this.queue = [];
    for (let i = 0; i < length; i++) {
      const from = oldText[i] || "";
      const to = newText[i] || "";
      const start = Math.floor(Math.random() * 40);
      const end = start + Math.floor(Math.random() * 40);
      this.queue.push({ from, to, start, end });
    }
    cancelAnimationFrame(this.frameRequest);
    this.frame = 0;
    this.update();
    return promise;
  }
  update() {
    let output = "";
    let complete = 0;
    for (let i = 0, n = this.queue.length; i < n; i++) {
      let { from, to, start, end, char } = this.queue[i];
      if (this.frame >= end) {
        complete++;
        output += to;
      } else if (this.frame >= start) {
        if (!char || Math.random() < 0.28) {
          char = this.randomChar();
          this.queue[i].char = char;
        }
        output += `<span class="dud">${char}</span>`;
      } else {
        output += from;
      }
    }
    this.el.innerHTML = output;
    if (complete === this.queue.length) {
      this.resolve();
    } else {
      this.frameRequest = requestAnimationFrame(this.update);
      this.frame++;
    }
  }
  randomChar() {
    return this.chars[Math.floor(Math.random() * this.chars.length)];
  }
}

// ——————————————————————————————————————————————————
// Example
// ——————————————————————————————————————————————————

const phrases_f = [
  "Html",
  "SCSS",
  "Bootstrap 5",
  "Tailwind CSS",
  "JavaScript",
  "TypeScript",
  "React.js",
  "Next.js",
  "Three.js",
];

const phrases_b = [
  "PHP",
  "Node.js",
  "MySQL",
  "Redux",
  "Docker",
  "Redis",
  "MongoDB",
];

const phrases_t = [
  "Visual Studio Code",
  "Git",
  "Github",
  "Netlify",
  "Postman",
  "AWS",
];

const el_f = document.querySelector(".front-end-text");
const fx_f = new TextScramble(el_f);

let counter_f = 0;
const next_f = () => {
  fx_f.setText(phrases_f[counter_f]).then(() => {
    setTimeout(next_f, 2000);
  });
  counter_f = (counter_f + 1) % phrases_f.length;
};
next_f();

const el_b = document.querySelector(".back-end-text");
const fx_b = new TextScramble(el_b);

let counter_b = 0;
const next_b = () => {
  fx_b.setText(phrases_b[counter_b]).then(() => {
    setTimeout(next_b, 2000);
  });
  counter_b = (counter_b + 1) % phrases_b.length;
};
next_b();

const el_t = document.querySelector(".tool-text");
const fx_t = new TextScramble(el_t);

let counter_t = 0;
const next_t = () => {
  fx_t.setText(phrases_t[counter_t]).then(() => {
    setTimeout(next_t, 2000);
  });
  counter_t = (counter_t + 1) % phrases_t.length;
};
next_t();

//skill hover
const f_skill = document.querySelectorAll(".f > div");
const f_card = document.querySelector(".f-card");
const f_card_text = document.querySelector(".f-card-t");
const f_card_icon = document.querySelector(".f-card-i");
const f_card_rank = document.querySelector(".f-card-rank");

f_skill.forEach(function (f_skill, index) {
  f_skill.addEventListener("mouseover", () => {
    f_card.style.transform = "rotateY(0deg)";

    switch (index) {
      case 0:
        f_card.style.backgroundColor = "#E34F26";
        f_card_icon.className += " htmli";
        f_card_text.innerHTML = "HTML";
        f_card_rank.innerHTML = "★★★★★";
        break;
      case 1:
        f_card.style.backgroundColor = "#1572B6";
        f_card_icon.className += " cssi";
        f_card_text.innerHTML = "CSS";
        f_card_rank.innerHTML = "★★★★★";
        break;
      case 2:
        f_card.style.backgroundColor = "#F7DF1E";
        f_card_icon.className += " jsi";
        f_card_text.innerHTML = "Javascript";
        f_card_rank.innerHTML = "★★★★☆";
        break;
      case 3:
        f_card.style.backgroundColor = "#7952B3";
        f_card_icon.className += " bootsi";
        f_card_text.innerHTML = "Bootstrap5";
        f_card_rank.innerHTML = "★★★★☆";
        break;
      case 4:
        f_card.style.backgroundColor = "#06B6D4";
        f_card_icon.className += " tailwindi";
        f_card_text.innerHTML = "TailwindCSS";
        f_card_rank.innerHTML = "★★★★☆";
        break;
      case 5:
        f_card.style.backgroundColor = "#61DAFB";
        f_card_icon.className += " reacti";
        f_card_text.innerHTML = "React.js";
        f_card_rank.innerHTML = "★★★★☆";
        break;
      case 6:
        f_card.style.backgroundColor = "#333333";
        f_card_icon.className += " threei";
        f_card_text.innerHTML = "Three.js";
        f_card_rank.innerHTML = "★★★★☆";
        break;
    }
  });
  f_skill.addEventListener("mouseout", () => {
    f_card.style.transform = "rotateY(180deg)";
    f_card_icon.className = "f-card-i";
  });
});

const b_skill = document.querySelectorAll(".b > div");
const b_card = document.querySelector(".b-card");
const b_card_text = document.querySelector(".b-card-t");
const b_card_icon = document.querySelector(".b-card-i");
const b_card_rank = document.querySelector(".b-card-rank");

b_skill.forEach(function (b_skill, index) {
  b_skill.addEventListener("mouseover", () => {
    b_card.style.transform = "rotateY(0deg)";

    switch (index) {
      case 0:
        b_card.style.backgroundColor = "#777BB4";
        b_card_icon.className += " phpi";
        b_card_text.innerHTML = "PHP";
        b_card_rank.innerHTML = "★★★★★";
        break;
      case 1:
        b_card.style.backgroundColor = "#339933";
        b_card_icon.className += " nodei";
        b_card_text.innerHTML = "Node.js";
        b_card_rank.innerHTML = "★★★☆☆";
        break;
      case 2:
        b_card.style.backgroundColor = "#4479A1";
        b_card_icon.className += " mysqli";
        b_card_text.innerHTML = "MySQL";
        b_card_rank.innerHTML = "★★★★☆";
        break;
      case 3:
        b_card.style.backgroundColor = "#764ABC";
        b_card_icon.className += " reduxi";
        b_card_text.innerHTML = "Redux";
        b_card_rank.innerHTML = "★★★★☆";
        break;
      case 4:
        b_card.style.backgroundColor = "#2496ED";
        b_card_icon.className += " dockeri";
        b_card_text.innerHTML = "Docker";
        b_card_rank.innerHTML = "★★★★★";
        break;
      case 5:
        b_card.style.backgroundColor = "#DC382D";
        b_card_icon.className += " redisi";
        b_card_text.innerHTML = "Redis";
        b_card_rank.innerHTML = "★★★☆☆";
        break;
      case 6:
        b_card.style.backgroundColor = "#47A248";
        b_card_icon.className += " mongoi";
        b_card_text.innerHTML = "Mongo";
        b_card_rank.innerHTML = "★★★★☆";
        break;
    }
  });
  b_skill.addEventListener("mouseout", () => {
    b_card.style.transform = "rotateY(180deg)";
    b_card_icon.className = "b-card-i";
  });
});

const t_skill = document.querySelectorAll(".t > div");
const t_card = document.querySelector(".t-card");
const t_card_text = document.querySelector(".t-card-t");
const t_card_icon = document.querySelector(".t-card-i");
const t_card_rank = document.querySelector(".t-card-rank");

t_skill.forEach(function (t_skill, index) {
  t_skill.addEventListener("mouseover", () => {
    t_card.style.transform = "rotateY(0deg)";

    switch (index) {
      case 0:
        t_card.style.backgroundColor = "#007ACC";
        t_card_icon.className += " vscodei";
        t_card_text.innerHTML = "VScode";
        t_card_rank.innerHTML = "★★★★★";
        break;
      case 1:
        t_card.style.backgroundColor = "#F05032";
        t_card_icon.className += " giti";
        t_card_text.innerHTML = "Git";
        t_card_rank.innerHTML = "★★★★★";
        break;
      case 2:
        t_card.style.backgroundColor = "#181717";
        t_card_icon.className += " githubi";
        t_card_text.innerHTML = "Github";
        t_card_rank.innerHTML = "★★★★★";
        break;
      case 3:
        t_card.style.backgroundColor = "#00C7B7";
        t_card_icon.className += " netlifyi";
        t_card_text.innerHTML = "Netlify";
        t_card_rank.innerHTML = "★★★★★";
        break;
      case 4:
        t_card.style.backgroundColor = "#FF6C37";
        t_card_icon.className += " postmani";
        t_card_text.innerHTML = "Postman";
        t_card_rank.innerHTML = "★★★★★";
        break;
      case 5:
        t_card.style.backgroundColor = "#FF9900";
        t_card_icon.className += " awsi";
        t_card_text.innerHTML = "AWS";
        t_card_rank.innerHTML = "★★★★☆";
        break;
    }
  });
  t_skill.addEventListener("mouseout", () => {
    t_card.style.transform = "rotateY(180deg)";
    t_card_icon.className = "t-card-i";
  });
});

const o_skill = document.querySelectorAll(".o > div");
const o_card = document.querySelector(".o-card");
const o_card_text = document.querySelector(".o-card-t");
const o_card_icon = document.querySelector(".o-card-i");
const o_card_rank = document.querySelector(".o-card-rank");

o_skill.forEach(function (o_skill, index) {
  o_skill.addEventListener("mouseover", () => {
    o_card.style.transform = "rotateY(0deg)";

    switch (index) {
      case 0:
        o_card.style.backgroundColor = "#A8B9CC";
        o_card_icon.className += " cshopi";
        o_card_text.innerHTML = "C#";
        o_card_rank.innerHTML = "★★★★☆";
        break;
      case 1:
        o_card.style.backgroundColor = "#00599C";
        o_card_icon.className += " cplusi";
        o_card_text.innerHTML = "C++";
        o_card_rank.innerHTML = "★★★★☆";
        break;
      case 2:
        o_card.style.backgroundColor = "#3776AB";
        o_card_icon.className += " pythoni";
        o_card_text.innerHTML = "Python";
        o_card_rank.innerHTML = "★★★☆☆";
        break;
      case 3:
        o_card.style.backgroundColor = "#FFFFFF";
        o_card_icon.className += " unityi";
        o_card_text.innerHTML = "Unity";
        o_card_text.style.color = "#000";
        o_card_rank.innerHTML = "★★★★★";
        o_card_rank.style.color = "#000";
        break;
      case 4:
        o_card.style.backgroundColor = "#F5792A";
        o_card_icon.className += " blenderi";
        o_card_text.innerHTML = "Blender";
        o_card_rank.innerHTML = "★★★☆☆";
        break;
      case 5:
        o_card.style.backgroundColor = "#31A8FF";
        o_card_icon.className += " photoshopi";
        o_card_text.innerHTML = "Photoshop";
        o_card_rank.innerHTML = "★★★★☆";
        break;
    }
  });
  o_skill.addEventListener("mouseout", () => {
    o_card.style.transform = "rotateY(180deg)";
    o_card_icon.className = "o-card-i";
    o_card_text.style.color = "#fff";
    o_card_rank.style.color = "#fff";
  });
});

//work function
const pjContentEL = document.querySelector(".pjc");
const pjImageEL = document.querySelector(".pjimg");
const pjNameEL = document.querySelector(".pjname");
const pjCpntentEL = document.querySelector(".pjcontent");
const pjSkillEL = document.querySelector(".pjskill");
const pjLinkEL = document.querySelector(".pjlink");

const pjBtnELs = document.querySelectorAll(".pj > aside");
pjBtnELs.forEach(function (pjBtnEL, index) {
  pjBtnEL.addEventListener("click", function () {
    switch (index) {
      case 0:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj0";
        pjNameEL.innerHTML = "U-topia / 2021";
        pjCpntentEL.innerHTML =
          "This project is a graduation project. This work is a work in which players recognize and solve problems by actively intervening in hidden problems in modern society through interaction with the work.";
        pjSkillEL.innerHTML =
          "Unity / C# / Xcode / Arduino / Image Processing / Adobe Photoshop / Adobe Animator";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute("href", "https://youtu.be/sEXMH38OdKM");
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-link"></i>';
        break;
      case 1:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj1";
        pjNameEL.innerHTML = "Post Processing / 2021";
        pjCpntentEL.innerHTML =
          "This is the game project that was created to enter the global popular game contest in the last semester. I was a team leader, a director, and a client developer. We won the contest and received a prize and a certificate.";
        pjSkillEL.innerHTML = "Unity / C# / Maya / Blender3d / Adobe Photoshop";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute("href", "https://youtu.be/VK1PjEPZd1E");
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-link"></i>';
        break;
      case 2:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj2";
        pjNameEL.innerHTML = "Trip to Vancouver / 2022";
        pjCpntentEL.innerHTML =
          "It's the first project I've worked on in class at Tomwood College. After coming to Canada, I organized the places I wanted to go and made it into a website.";
        pjSkillEL.innerHTML = "HTML / CSS";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute(
          "href",
          "https://tranquil-druid-f145d7.netlify.app/"
        );
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-up-right-from-square"></i>';
        break;
      case 3:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj3";
        pjNameEL.innerHTML = "Save The Animals / 2022";
        pjCpntentEL.innerHTML =
          "I created more pages than the first project, and I tried to build it like a commercial website.";
        pjSkillEL.innerHTML = "HTML / CSS";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute(
          "href",
          "https://coruscating-churros-4b56df.netlify.app/"
        );
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-up-right-from-square"></i>';
        break;
      case 4:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj4";
        pjNameEL.innerHTML = "PURL | Picture UR Life / 2022";
        pjCpntentEL.innerHTML =
          "It is the first team project to use the back-end skill. The page was implemented using php, and I implemented a map function, a search function, and a download function.";
        pjSkillEL.innerHTML = "HTML / CSS / PHP / React.js";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute("href", "https://github.com/LinwenK/PURL");
        pjLinkEL.setAttribute("target", "_blank");
        break;
      case 5:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj5";
        pjNameEL.innerHTML = "Strabucks Clone Coding (KR) / 2021";
        pjCpntentEL.innerHTML =
          "It is a Starbucks clone coding project that I worked on to study front-end before coming to Canada. It is the first project to use JavaScript.";
        pjSkillEL.innerHTML = "HTML / CSS / JS";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute(
          "href",
          "https://starlit-wisp-faf26d.netlify.app/"
        );
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-up-right-from-square"></i>';
        break;
      case 6:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj6";
        pjNameEL.innerHTML = "Blind Clone Coding (KR) / 2023";
        pjCpntentEL.innerHTML =
          "I made this project after I decided to become a full stack web developer. This is the Blind clone coding project and I made this project from scratch. The work took about a month, and everything from front-end to back-end to publishing was done alone.";
        pjSkillEL.innerHTML =
          "Front-end: HTML / CSS / React / Next.js <br> Back-end: Redux / Express / MongoDB / AWS S3 <br> Dev-ops: Netlify / CloudType";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute("href", "https://junsblindclone.netlify.app/");
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-up-right-from-square"></i>';
        break;
      case 7:
        pjImageEL.classList = "pjimg";
        pjImageEL.classList += " pj7";
        pjNameEL.innerHTML = "Carhub Clone Coding / 2023";
        pjCpntentEL.innerHTML =
          "This is the first project I used typescript. I made this project with typescript and NextJs. And I also used TailwindCSS and HeadlessUI for designing components. This project connects to cars api of rapidAPI. So you can check a number of cars in the project.";
        pjSkillEL.innerHTML =
          "Front-end: HTML / TailwindCSS / Typescript / Next.js <br>";
        pjLinkEL.style.display = "block";
        pjLinkEL.setAttribute("href", "https://carhubclonecoding.netlify.app/");
        pjLinkEL.setAttribute("target", "_blank");
        pjLinkEL.innerHTML = '<i class="fa-solid fa-up-right-from-square"></i>';
        break;
    }
    gsap.to(pjContentEL, 2, {
      onInit: function () {
        pjContentEL.style.opacity = 0;
      },
      opacity: 1,
      ease: "power1.out",
    });
  });
});

(function () {
  emailjs.init("1owB8dTsM9rMgT5Ag");
})();
const emailFlag = document.querySelector("#email-flag");
window.onload = function () {
  document
    .getElementById("contact-form")
    .addEventListener("submit", function (event) {
      event.preventDefault();
      // generate a five digit number for the contact_number variable
      this.contact_number.value = (Math.random() * 100000) | 0;
      // these IDs from the previous steps
      emailjs.sendForm("service_b5ubyag", "template_6ahajek", this).then(
        function () {
          console.log("SUCCESS!");
          emailFlag.innerText = "Your email has been sent successfully!";
          emailFlag.style.color = "#03C988";
        },
        function (error) {
          console.log("FAILED...", error);
          emailFlag.innerText = "The email was not delivered due to an error.";
          emailFlag.style.color = "#D61355";
        }
      );
    });
};
